import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { immigrateCategoryAPI } from 'features/immigrate-category/api'
import {
  IMMIGRATE_CATEGORY_REMOVE_REQUEST,
  IMMIGRATE_CATEGORY_REMOVE_SUCCESS,
  IMMIGRATE_CATEGORY_REMOVE_FAILED,
} from './actionTypes'

export const immigrateCategoryRemovePA = createPromiseAction(
  IMMIGRATE_CATEGORY_REMOVE_REQUEST,
  IMMIGRATE_CATEGORY_REMOVE_SUCCESS,
  IMMIGRATE_CATEGORY_REMOVE_FAILED
)()

function* remove(action) {
  try {
    const { id } = action.payload

    const response = yield call(immigrateCategoryAPI.deleteCategory, id)
    const { data } = response

    yield put(immigrateCategoryRemovePA.success({}))

    resolvePromiseAction(action, { id })
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* removeSaga() {
  yield takeEvery(immigrateCategoryRemovePA.request, remove)
}
